module.exports = __webpack_public_path__ + "static/img/logo-jira.cb154bf2.svg";